export interface PublicSupportChatMessage {
  id: string;
  clientMessageId?: string | null;
  replyToClientMessageId?: string | null;
  direction: 'inbound' | 'outbound';
  channel: 'whatsapp' | 'web';
  body: string;
  senderType: 'client' | 'bot' | 'operator';
  deliveryStatus:
    'received' | 'pending' | 'sent' | 'delivered' | 'read' | 'failed' | null;
  createdAt: string;
}

export interface PublicSupportChatSession {
  sessionToken: string;
  expiresAt: string;
  messages: PublicSupportChatMessage[];
}

export interface SupportChatApi {
  createPublicSupportChatSession(): Promise<PublicSupportChatSession>;
  getPublicSupportChatMessages(
    sessionToken: string
  ): Promise<PublicSupportChatMessage[]>;
  acknowledgePublicSupportChatMessages(input: {
    sessionToken: string;
    messageIds: string[];
  }): Promise<number>;
  sendPublicSupportChatMessage(input: {
    sessionToken: string;
    clientMessageId: string;
    text: string;
    pagePath: string | null;
  }): Promise<{
    inbound: PublicSupportChatMessage;
    outbound: PublicSupportChatMessage | null;
    outcome?: 'review_pending';
  }>;
  isPublicSupportChatSessionRejected(error: unknown): boolean;
  getPublicSupportChatRetryAfterSeconds(error: unknown): number | null;
}

export class PublicSupportChatAnswerUnavailableError extends Error {
  constructor(
    readonly inbound: PublicSupportChatMessage,
    readonly canContinue: boolean = false
  ) {
    super('support_answer_unavailable');
    this.name = 'PublicSupportChatAnswerUnavailableError';
  }
}
